import { render, staticRenderFns } from "./AddDiscount.vue?vue&type=template&id=05c1af1a&"
import script from "./AddDiscount.vue?vue&type=script&lang=ts&"
export * from "./AddDiscount.vue?vue&type=script&lang=ts&"
import style0 from "./AddDiscount.vue?vue&type=style&index=0&id=05c1af1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports